import Promise$1 from 'bluebird';
import { Price } from './Price.js';
import { Products } from './Products.js';
import * as qs from 'qs';
import { PrintingFormat, Label } from '../../../models/Label/Label.js';
import { RepurchaseResponse } from '../../../models/Repurchase/RepurchaseResponse.js';
import { ShipmentActions } from '../../../models/Shipment/ShipmentActions.js';
import { DropOff } from '../../../models/DropOff/DropOff.js';
import { Shipment } from '../../../models/Shipment/Shipment.js';

function hasOriginalFormat(formatsToAsk) {
  return formatsToAsk.find(format => format.size === PrintingFormat.ORIGINAL);
}
function paramsSerializer(parameters) {
  return qs.stringify(parameters, {
    arrayFormat: 'comma'
  });
}
class Shipments {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.price = new Price(apiClient);
    this.products = new Products(apiClient);
  }
  getShipments(params) {
    return this.apiClient.get('pro/shipments', params, undefined, paramsSerializer).then(response => {
      const {
        content,
        pagination
      } = response.data;
      return {
        content: content.map(shipment => createProShipmentFromResponse(shipment)),
        pagination: {
          currentPage: pagination.current_page,
          totalElements: pagination.total_registers,
          totalPages: pagination.total_pages
        }
      };
    });
  }
  getShipment(shipmentReference) {
    return this.apiClient.get(`pro/shipments/${shipmentReference}`).then(response => createProShipmentFromResponse(response.data));
  }
  getShipmentLabels(shipmentReference) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const formatsToAsk = [...formats];
    if (!hasOriginalFormat(formatsToAsk)) {
      formatsToAsk.push({
        size: PrintingFormat.ORIGINAL
      });
    }
    return this.apiClient.post(`pro/shipments/${shipmentReference}/labels`, {
      formats: formatsToAsk
    }).then(response => Label.createFromResponse(response.data));
  }
  getCombinedLabels(shipmentReferences, disposition) {
    const data = {
      disposition,
      item_size: PrintingFormat.A6,
      paper_size: PrintingFormat.A4,
      references: shipmentReferences,
      with_guide_line: true
    };
    return this.apiClient.post('/pro/shipments/labels/group', data).then(res => {
      return new Label(undefined, undefined, {
        url: res.data.url
      }, undefined);
    });
  }
  getShipmentByOrderId(orderId) {
    return this.apiClient.get(`pro/shipments/by-order-id/${orderId}`).then(response => createProShipmentFromResponse(response.data));
  }
  createShipmentForMultiLabel(shipmentReference) {
    return this.apiClient.post(`pro/shipments/multi-label/${shipmentReference}`).then(response => Shipment.createFromResponse(response.data));
  }
  repurchase(orderId) {
    return this.apiClient.post(`pro/shipments/by-order-id/${orderId}/re-purchase`).then(() => RepurchaseResponse.OK).catch(error => {
      if (error.status === 400 || error.status === 404) {
        return Promise$1.reject(RepurchaseResponse.NO_REPURCHASE_POSSIBLE);
      }
      return Promise$1.reject(RepurchaseResponse.CANNOT_COMPLETE_REPURCHASE);
    });
  }
}
const createProShipmentFromResponse = shipment => {
  const {
    actions,
    data,
    inbox,
    step,
    view: {
      to: {
        drop_off: dropOff
      }
    }
  } = shipment;
  return {
    actions: ShipmentActions.createFromResponse(actions),
    data: Shipment.createFromResponse(data),
    dropOff: dropOff ? DropOff.createFromResponse(dropOff) : undefined,
    inbox,
    step
  };
};

export { Shipments };
//# sourceMappingURL=Shipments.js.map
